import { getMenus } from "./API";

export const getUserMenu = async (userDiv) => {
  try {
    const menus = await getMenus(userDiv); 
    return menus.map((menu) => ({
      menuID : menu.menuID,
      menuNm: menu.menuNm,
      menuPath: menu.menuPath,
    }));
  } catch (error) {
    return []; 
  }
};
